import DeviceOverview from '../../features/device/layouts/overview';

export default function DevicePage() {
    return <DeviceOverview />;
}
